import React, { useEffect } from 'react'
import InviteUseTab1 from './InviteUseTab1'
import InviteUseTab2 from './InviteUseTab2'
import * as common from '../../../assets/js/common.js'
import $ from 'jquery'

const InviteList = () => {
  useEffect(() => {
    $('.nav-wrap .current-menu')
      .unbind('click')
      .bind('click', function (e) {
        e.preventDefault()
        $(this).toggleClass('on')
      })

    if (common.getDeviceType() !== 'MobileApp') {
      // Tab Style
      const $tabsNav = $('.tabs'),
        $tabsNavLis = $tabsNav.children('li')

      $tabsNav.each(function () {
        const $this = $(this)

        if (localStorage.getItem('invtTab') === '2') {
          $this.children('li').first().removeClass('on')
          $this.next().children('.tab-cont').stop(true, true).hide().eq(1).show()
          $this.children('li').eq(1).addClass('on').stop(true, true).show()
          localStorage.removeItem('invtTab')
        } else {
          $this.next().children('.tab-cont').stop(true, true).hide().first().show() // first index : 0
          $this.children('li').first().addClass('on').stop(true, true).show()
        }
      })

      $tabsNavLis.on('click', function (e) {
        const $this = $(this)
        $this.siblings().removeClass('on').end().addClass('on')
        $this.parent().next().children('.tab-cont').stop(true, true).hide().siblings($this.find('a').attr('href')).fadeIn(500)
        e.preventDefault()
      })
    } else {
      /** 모바일 탭 컨트롤 */
      const $tabsNavMenu = $('.nav-menu'),
        $tabsNavMenuLis = $tabsNavMenu.children('li')

      $tabsNavMenu.each(function () {
        const $this = $(this)
        $this.parent().next().children('.tab-cont').stop(true, true).hide().first().show()
        $this.children('li').first().addClass('on').stop(true, true).show()
      })

      $tabsNavMenuLis.on('click', function (e) {
        const $this = $(this)
        $('.nav-wrap').children().first().text($this.text())
        $this.siblings().removeClass('on').end().addClass('on')
        $this.parent().parent().next().children('.tab-cont').stop(true, true).hide().siblings($this.find('a').attr('href')).fadeIn(500)
        $('.current-menu').trigger('click')
        e.preventDefault()
      })
    }
  }, [])

  return (
    <div id="contents">
      <div className="content-header">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>이용자 관리</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <span>마이페이지</span>
          <em>이용자 관리</em>
        </div>
      </div>

      {common.getDeviceType() !== 'MobileApp' ? (
        <ul className="nav-tab tabs">
          <li>
            <a href="#use-tab1" id="use-tab1">
              권한위임
            </a>
          </li>
          <li>
            <a href="#use-tab2" id="use-tab2">
              초대하기
            </a>
          </li>
        </ul>
      ) : (
        <div className="nav-wrap">
          <a href="#" className="current-menu">
            권한위임
          </a>
          <ul className="nav-menu">
            <li className="on">
              <a href="#use-tab1" id="use-tab1">
                권한위임
              </a>
            </li>
            <li>
              <a href="#use-tab2" id="use-tab2">
                초대하기
              </a>
            </li>
          </ul>
        </div>
      )}
      <div className="tab-container">
        <InviteUseTab1 />
        <InviteUseTab2 />
      </div>
    </div>
  )
}

export default InviteList
